var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_vm.userCreated
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Email" } }, [_vm._v("Email:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "email", placeholder: "Work email of an user" },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.email = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Email", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "FirstName" } }, [
                _vm._v("First name:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.firstName,
                    expression: "firstName",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "First name of an user" },
                domProps: { value: _vm.firstName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.firstName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "FirstName", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "LastName" } }, [
                _vm._v("Last name:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lastName,
                    expression: "lastName",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Last name of an user" },
                domProps: { value: _vm.lastName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.lastName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "LastName", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.setInitialPassword,
                  expression: "setInitialPassword",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "setInitialPassword" },
              domProps: {
                checked: Array.isArray(_vm.setInitialPassword)
                  ? _vm._i(_vm.setInitialPassword, null) > -1
                  : _vm.setInitialPassword,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.setInitialPassword,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.setInitialPassword = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.setInitialPassword = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.setInitialPassword = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "setInitialPassword" },
              },
              [_vm._v("Set initial password manually")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.setInitialPassword,
                  expression: "setInitialPassword",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "Password" } }, [
                    _vm._v("Initial password:"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "password" },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ValidationError", {
                    attrs: {
                      context: "Password",
                      errors: _vm.validationErrors,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.password,
                      expression: "password",
                    },
                  ],
                  staticClass: "form-group",
                },
                [
                  _c("label", { attrs: { for: "PasswordConfirmation" } }, [
                    _vm._v("Initial password confirmation:"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirmation,
                        expression: "passwordConfirmation",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.passwordConfirmationInvalid },
                    attrs: { type: "password" },
                    domProps: { value: _vm.passwordConfirmation },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.passwordConfirmation = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v("Initial password confirmation doesn't match"),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInitial || _vm.statusInvalid,
                  expression: "statusInitial || statusInvalid",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: {
                type: "button",
                disabled: _vm.passwordConfirmationInvalid,
              },
              on: { click: _vm.handleCreateUserCommandV1 },
            },
            [_vm._v("Create")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.statusInvoking,
                  expression: "statusInvoking",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button", disabled: "" },
            },
            [_vm._v("Creating...")]
          ),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("h4", { staticClass: "fg-color-blue" }, [
            _vm._v(
              "User was created and initial system generated password was sent on " +
                _vm._s(_vm.email)
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-success text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: {
                href: `/#/admin/organizations/users/manage/type/${_vm.email}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-external-link",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Manage user roles")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "h4",
            { staticClass: "fg-color-blue", staticStyle: { margin: "20px 0" } },
            [_vm._v("or")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-secondary text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: {
                href: `/#/admin/organizations/users/manage/workspaces/${_vm.email}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-external-link",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Manage user workspaces")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "h4",
            { staticClass: "fg-color-blue", staticStyle: { margin: "20px 0" } },
            [_vm._v("or")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary text-white",
              staticStyle: { padding: "0.7em 2em" },
              on: { click: _vm.handleFinish },
            },
            [
              _c("i", {
                staticClass: "fa fa-user-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Add another user")]),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Create a new user")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }